import React from 'react'
import styled from "./SideDiv1.module.css"
const SideDiv9 = () => {
  return (
    <div style={{textAlign:"left"}} className={styled.div1} >
      <h3>Naukri Learning Courses</h3>
      <p style={{color:"#4a90e2"}}>
      Data Science Courses<br/>
Machine Learning Courses<br/>
Big Data Courses<br/>
Programming Courses<br/>
Business Analytics Courses<br/>
Project Management Courses<br/>
Web Design Courses<br/>
DevOps and Cloud computing Courses<br/>
Marketing Courses<br/>
Accounting and Finance Courses<br/>
Banking Courses<br/>
Logistics and Supply Chain Courses<br/>
Strategy and Leadership Courses
      </p>
    </div>
  )
}

export default SideDiv9